import React, { useContext, useEffect } from "react";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import { AppStrings } from "../../utils/constants/AppStrings";
import { usePageTitle } from "../CommonComponents/Layout/PageTitleContext";
import AccountConfig from "./AccountConfig/AccountConfig";

/**
 * Sportsbook → Configuration: per-deployment account config (DynamoDB).
 */
const ConfigurationAccountConfig: React.FC = () => {
  usePageTitle(AppStrings.ACCOUNT_CONFIG);
  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "ACCOUNT_CONFIG");
  }, [setActiveSidebarTab]);

  return (
    <>
      <AccountConfig />
    </>
  );
};

export default ConfigurationAccountConfig;
